<template>
  <div class="p-header">
    <div class="p-header-inner">
      <img class="p-header-logo" src="@/assets/images/home2023/logo-white.svg" alt="" @click="onClickLogo" />
    <div class="p-header-navigation">
    </div>

    <div class="p-header-right">
      <div class="p-header-contact">
        <img class="p-header-phone-icon" src="@/assets/images/ico-phone.png" alt="">
        <div>
          <div class="p-header-phone">400-677-5005</div>
          <div class="p-header-time">服务时间 9:00 - 18:00</div>
        </div>
      </div>
      <kd-button v-if="loginLoading && !userInfo" class="p-header-right-btn black-border-btn" @click="toLogin">登录</kd-button>

      <kd-dropdown
        trigger="hover"
        placement="bottom-end"
        @select="onSelectAvatarMenu"
      >
        <div v-show="loginLoading && userInfo" style="height: 50px;width: 32px;" slot="reference">
          <img
            v-show="loginLoading && userInfo"
            class="p-header-right-profile"
            
            :src="userInfo && userInfo.pic"
            alt=""
          />
        </div>
        <div v-if="userInfo" class="c-ch-avatar__menu-info">
          <img class="c-ch-avatar__menu-avatar" :src="userInfo.pic" alt="">
          <div class="c-ch-avatar__menu-name">{{ userInfo.nickname }}</div>
        </div>
        <kd-menu-item
          v-for="(item, index) in avatarMenuList"
          :key="index"
          :index="item.type"
        >
          <div class="c-ch-avatar__menu-item">{{ item.name }}</div>
        </kd-menu-item>
      </kd-dropdown>
    </div>
    </div>
    <!-- <button @click="toSwitchAccount">切换</button> -->
  </div>
</template>

<script>
import Login from '@/common/login';
import { queryUserInfo, logout } from '@/common/request';
import { showMultiAccountGuide } from "@plus/epplatform/pkgs/multiAccount";
import { companyStart } from '@/common/epplatform';
import { common } from '@/common/constants/config';
import { getFromPage, getPageName } from '@/common/utils/index'
import infoCollect from '@/common/infoCollect';
import { navAuthMenuItems } from './config';
import { openBuyPage } from '@/common/utils/business'

export default {
  name: 'HomeView',
  data() {
    return {
      loginLoading: false,
      isPc: true,
      currentPage: this.$router.history.current.path,
      userProfile: 'https://img.qwps.cn/1385942316?imageMogr2/thumbnail/180x180!&k=1665457890641338788',
      userInfo: null,
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.currentPage = val.path
      },
      // 首次执行
      immediate: true,
    },
  },
  methods: {
    toLogin() {
      Login.login()
    },
    toSwitchAccount() {
      Login.switchAccount()
    },
    toPage(page) {
      var name = ''
      if (page === '/home') {
        name = 'head_home'
      } else if (page === '/price') {
        name = 'head_price'
      } else if (page === '/help') {
        name = 'head_help'
      }
      infoCollect.dwCollectData('button_click', name, 'PC', 
        {'page_name': getPageName(), 'from_item': getFromPage()}
      )

      var fromPage = ''
      if (location.pathname.includes('/home')) {
        fromPage = 'edu_web_home_page'
      } else if (location.pathname.includes('/price')) {
        fromPage = 'edu_web_price_page'
      } else if (location.pathname.includes('/help')) {
        fromPage = 'edu_web_help_page'
      }

      this.currentPage = page
      this.$router.push(`${page}?fromPage=${fromPage}`)
    },
    contactSales() {
      infoCollect.dwCollectData('button_click', 'head_contact_sales', 'PC', 
        {'page_name': getPageName(), 'from_item': getFromPage()}
      )
      window.open(common.contactSales)
    },
    async init () {
      try {
        this.userInfo = await queryUserInfo()
      } finally {
        this.loginLoading = true
      }
    },
    onClickLogo () {
      this.$router.push('/2023/home')
    },

    onSelectAvatarMenu (type) {
      const config = this.avatarMenuList.find(item => item.type === type);
      this.handleAvatarMunuSelected(config);
    },

    async handleAvatarMunuSelected (config) {
      const { type } = config || {};

      switch (type) {
        case 'KDOCS':
          config?.url && window.open(config?.url, '_blank');
          break;

        case 'CREATE_COMPANY':
          if (this.userInfo) {
            companyStart(
              this.userInfo.companyid,
              this.userInfo.userid,
            );
          }
          break;

        case 'SWITCH_ACCOUNT':
          this.toSwitchAccount();
          break;

        case 'QA':
          config?.url && window.open(config?.url, '_blank');
          break;

        case 'LOGOUT':
          try {
            await logout();
            window.location.reload();
          } catch (e) {
            console.error('退出登陆异常:', e);
          }
          break;
      }
    },

    toSwitchAccount () {
      showMultiAccountGuide({
        title: '请选择账号',
        closed: true,
        selectText: '切换',
        onSwitchSuccess: () => {
          window.location.reload();
        }
      });
    },
    clickAuthItem(config) {
      const { link } = config || {};
      window.open(link, '_blank');
    },
    handleBuy() {
      openBuyPage('_self', { serviceVal: 'wps365_edu_application' })
    },
  },
  created () {
    this.navAuthMenuItems = navAuthMenuItems;
    this.avatarMenuList = [
      {
        name: '金山文档｜WPS云文档',
        type: 'KDOCS',
        url: 'https://www.kdocs.cn/latest',
      },
      {
        name: '创建新机构',
        type: 'CREATE_COMPANY',
      },
      {
        name: '切换账号',
        type: 'SWITCH_ACCOUNT',
      },
      {
        name: '帮助与反馈',
        type: 'QA',
        url: 'https://plus.wps.cn/blog/service',
      },
      {
        name: '退出',
        type: 'LOGOUT',
      },
    ]
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.p-header {
  width: 100%;
  height: 64px;
  min-width: 768px;
  background: #FFFFFF;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  box-shadow: rgba(116, 134, 163, 0.04) 0px 1px 2px 0px, rgba(116, 134, 163, 0.1) 0px 2px 8px 0px;

  &-inner {
    overflow-y: overlay;
    display: flex;
    width: 100%;
  }
  &-logo {
    width: 131px;
    height: 22px;
    margin-top: 22px;
    margin-left: 32px;
    margin-right: 48px;
    cursor: pointer;
  }

  &-navigation {
    display: flex;
  }

  &-tab {
    font-weight: 400;
    font-size: 16px;
    line-height: 40px;
    line-height: 64px;
    letter-spacing: 0.02em;
    color: #000000;
    margin-right: 32px;
    cursor: pointer;

    & .arrow {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image: url('@/assets/images/header/arrow.svg');
      background-size: 100%;
      background-repeat: no-repeat;
      position: relative;
      top: 3px;
      left: 3px;
    }

    &:hover {
      position: relative;
      &::after{
        content: '';
        display: inline-block;
        width: 100%;
        height: 3px;
        border-radius: 4px;
        position: absolute;
        left: 0;
        bottom: 0;
        background-color: #0D0D0D;
      }
    }
  }

  &-tab-activated {
    position: relative;
    &::after{
      content: '';
      display: inline-block;
      width: 100%;
      height: 3px;
      border-radius: 4px;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #0D0D0D;
    }
  }

  &-right {
    position: absolute;
    right: 16px;
    line-height: 64px;
    display: flex;
    margin-top: 15px;
    &-btn {
      width: 96px;
      height: 32px;
      margin-right: 16px;
      font-size: 14px;
      padding: 0;
    }

    &-profile {
      width: 32px;
      height: 32px;
      border: 1px solid #FFFFFF;
      border-radius: 16px;
      cursor: pointer;
      position: relative;
      top: -6px;
    }
  }

  &-contact {
    display: flex;
    margin-right: 16px;
    line-height: 64px;
  }

  &-phone-icon {
    width: 24px;
    height: 24px;
    margin-left: 10px;
    margin-right: 16px;
    margin-top: 4px;
  }

  &-phone {
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    color: rgba(13, 13, 13, 0.9);
  }

  &-time {
    font-size: 12px;
    line-height: 12px;
    margin-top: 4px;
    color: rgba(13, 13, 13, 0.66);
  }

}

@media (max-width: 1100px) {
  .p-header-navigation {
    display: none;
  }
}

@media (max-width: 860px) {
  .p-header-navigation {
    display: none;
  }
  .p-header-contact {
    display: none;
  }
}

.c-ch-avatar__menu {
  &-info {
    width: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    overflow: hidden;
  }

  &-avatar {
    display: block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-bottom: 6px;
  }

  &-name {
    width: 100%;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
}
</style>

<style lang="scss">
.c-ch-avatar__menu-item {
  width: 240px;
  height: 40px;
  line-height: 40px !important;
  font-size: 16px !important;
  text-align: center !important;
}

.p-header {
  & .a-menu {
    padding: 12px;
    border-radius: 8px;
  }

  & .a-menu-item {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & .a-menu-item:hover {
    background: none;
  }

  & .a-menu-item-content {
    font-size: 16px;
    border-radius: 8px;
    height: 36px;
    line-height: 36px;
    padding: 0 16px;
    
    &:hover {
      background-color: #eee;
    }
  }
}
</style>
